export default "/kiban/_next/static/images/planBgacsp-4168e7ad3aef5b8ba04b719d16023089.png";